import { FC, ReactNode } from "react";
import cx from "classnames";

type FormBigGroupProps = {
  title: string;
  description: string;
  className?: string;
  appendOnBottom?: ReactNode;
};
export const FormBigGroup: FC<FormBigGroupProps> = ({
  title,
  description,
  className,
  children,
  appendOnBottom,
}) => {
  return (
    <div className={cx("grid grid-cols-1 gap-4 md:grid-cols-12", className)}>
      <div className="md:col-span-4">
        <h3 className="mb-4 text-2xl font-bold">{title}</h3>
        <div className="text-gray-500">{description}</div>
        {!!appendOnBottom && <div>{appendOnBottom}</div>}
      </div>

      <div className="md:col-span-8">{children}</div>
    </div>
  );
};
